import React from "react";
import ReceiptLibraryPage from "components/common/receiptLibrary/ReceiptLibraryPage";

const ReceiptLibrary: React.FC = () => <ReceiptLibraryPage />;

export default ReceiptLibrary;
